var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.15 12.667 1.484-7.862a3 3 0 0 1 3.505-2.39l7.86 1.483a3 3 0 0 1 2.392 3.505l-1.67 8.844M7.15 12.667l-.742 3.93a3 3 0 0 0 2.391 3.505l7.861 1.484a3 3 0 0 0 3.505-2.391l.556-2.948M7.15 12.667l4.338-1.42 2.966 5.852 6.267-.852M2.301 11.86 1.589 7.1a3 3 0 0 1 2.524-3.41l5.739-.816M2.3 11.86l1.062 7.109a3 3 0 0 0 3.41 2.523l5.093-.777M2.3 11.86l2.927-3.396 2.346 1.358m8.485 1.474a2.5 2.5 0 1 0 .928-4.913 2.5 2.5 0 0 0-.928 4.913Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages);
export default __webpack_public_path__ + "static/media/images.57214ae359e8c8a4bc22aa22c5c614a6.svg";
export { ForwardRef as ReactComponent };